import styled from 'styled-components';

export const MainPageWrapper = styled.div`
  background-color: beige;
  height: 100vh;
  width: 100vw;
  font-family: 'Roboto', sans-serif;
`;
